import { useEffect, useState } from "react";
import { getCategoriesList, createCategory } from "../../../services/adminService";
import { toast } from "react-toastify";
import { deleteCategory } from "../../../services/adminService"; 

const AdminCategories = () => {
  const [categories, setCategories] = useState([]);
  const [newCategoryName, setNewCategoryName] = useState("");
  const [creatingCategory, setCreatingCategory] = useState(false);
  const [loading, setLoading] = useState(true);

  // Fetch categories on mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const categoryData = await getCategoriesList();
        setCategories(categoryData);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
        toast.error("Failed to load categories.");
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleCreateCategory = async () => {
    if (!newCategoryName.trim()) return;

    try {
      setCreatingCategory(true);
      const created = await createCategory({ name: newCategoryName.trim() });
      setCategories((prev) => [created, ...prev]);
      setNewCategoryName("");
      toast.success(`Category "${created.name}" created`);
    } catch (error) {
      console.error("Failed to create category:", error);
      toast.error("Category already exists or failed to create.");
    } finally {
      setCreatingCategory(false);
    }
  };

  const handleDelete = async (categoryId, categoryName) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete "${categoryName}"?`
    );

    if (!confirmDelete) return;

    try {
      await deleteCategory(categoryId);

      setCategories(prev =>
        prev.filter(category => category.id !== categoryId)
      );

      toast.success("Category deleted successfully");
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete category");
    }
  };

  return (
    <div className="admin-categories">
      <h2>Service Categories</h2>

      <div className="category-create-row">
        <input
          type="text"
          placeholder="New category name"
          value={newCategoryName}
          onChange={(e) => setNewCategoryName(e.target.value)}
        />
        <button onClick={handleCreateCategory} disabled={creatingCategory}>
          {creatingCategory ? "Adding..." : "Add Category"}
        </button>
      </div>

      {categories.length === 0 ? (
        <p>No categories found.</p>
      ) : (
        <ul>
          {categories.map((cat) => (
            <li key={cat.id} className="list-row">
              <span className="row-main">{cat.name}</span>

              <div className="row-right">
                <span className="row-date">
                  {new Date(cat.created_at).toLocaleString([], {
                    year: "numeric",
                    month: "short",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </span>

                <i
                  className="fa-solid fa-trash"
                  onClick={() => handleDelete(cat.id, cat.name)}
                ></i>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AdminCategories;
